/**
 * Decodes and parses a JWT auth token and returns it's payload.
 */ export const parseAuthToken = (token)=>{
    let parsedToken;
    try {
        const tokenPayload = token.split('.')[1];
        const decodedToken = window.atob(tokenPayload);
        parsedToken = JSON.parse(decodedToken);
    } catch (e) {
        throw new Error('Failed to decode and parse auth token.');
    }
    return parsedToken;
};
/**
 * Parses a JWT auth token and returns it's user ID (sub) property.
 */ export const getUserIdFromAuthToken = (token)=>{
    const parsedToken = parseAuthToken(token);
    if (!parsedToken.sub) throw new Error('Cannot find user ID (sub) property from auth token.');
    return parsedToken.sub;
};

//# sourceMappingURL=auth-token-utils.js.map